/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/range_intersects.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns true if the two arguments overlap. The relation is symmetric — argument order does not matter. Supports all combinations of ranges and corresponding scalar types. When both arguments are scalar values, this is equivalent to `a == b`.',
  examples: [
    'FROM employees\n| WHERE RANGE_INTERSECTS(hire_date, TO_DATE_RANGE("1985-02-01..1985-03-01"))\n| KEEP emp_no, hire_date\n| SORT emp_no',
  ],
  params: {
    left: 'First value (point or range).',
    right: 'Second value (point or range).',
  },
};

export default docs;
